// import entryTzCqMerge from '../components/administration/entryTzCqMerge.vue'
// import SaleTzCqMerge from '../components/administration/saleTzCqMerge'
// import AddEntryTzCqMerge from '../components/administration/addEntryTzCqMerge'
// import editEntryTzCqMerge from '../components/administration/editEntryTzCqMerge'
// import editSaleTzCqMerge from '../components/administration/editSaleTzCqMerge'
// import imgUploadCqMerge from '../components/administration/imgUploadCqMerge.vue'
// import viewEntryTzCqMerge from '../components/administration/viewEntryTzCqMerge.vue'
// import addSaleTzCqMerge from '../components/administration/addSaleTzCqMerge.vue'
// import viewSaleTzCqMerge from '../components/administration/viewSaleTzCqMerge.vue'
// import editSupplierMerge from '../components/administration/editSupplierMerge.vue'
// import newSupplierMerge from '../components/administration/newSupplierMerge.vue'
// import supplierMgmMerge from '../components/administration/supplierMgmMerge.vue'
// import viewSupplierMerge from '../components/administration/viewSupplierMerge.vue'
// import ClientMgmMerge from '../components/administration/clientMgmMerge'
// import NewClientMerge from '../components/administration/newClientMerge'
// import ViewClientMerge from '../components/administration/viewClientMerge'
// import EditClientMerge from '../components/administration/editClientMerge'
// import StocksMerge from '../components/administration/stocksMerge'
// import EditStocksMerge from '../components/administration/editStocksMerge'
// import viewStocksMerge from '../components/administration/viewStocksMerge'
// import MarketMerge from '../components/administration/marketMerge'
// import EditMarketMerge from '../components/administration/editMarketMerge'
// import ViewMarketMerge from '../components/administration/viewMarketMerge'
// import newStocksMerge from '../components/administration/newStocksMerge.vue'
// import newMarketMerge from '../components/administration/newMarketMerge.vue'

export default [
    {
        path: 'administration/entryTzCqMerge',
        // component: entryTzCqMerge,
        component: resolve => require(['@/components/administration/entryTzCqMerge'],resolve),
        name:"EntryTzCqMerge",
        meta:{
            id:'721',
            node:'administration',
            url:'entryTzCqMerge',
        }
    },
    {
        path: 'administration/saleTzCqMerge',
        component: resolve => require(['@/components/administration/saleTzCqMerge'],resolve),
        name:"SaleTzCqMerge",
        meta:{
            id:'727',
            node:'administration',
            url:'saleTzCqMerge',
        }
    },
    {
        path: 'administration/addEntryTzCqMerge',
        component: resolve => require(['@/components/administration/addEntryTzCqMerge'],resolve),
        name:'AddEntryTzCqMerge',
        meta:{
            id:'722',
            node:'administration',
            url:'addEntryTzCqMerge',
        }
    },
    {
        path: 'administration/editEntryTzCqMerge',
        component: resolve => require(['@/components/administration/editEntryTzCqMerge'],resolve),
        name:'EditEntryTzCqMerge',
        meta:{
            id:'723',
            node:'administration',
            url:'editEntryTzCqMerge',
        }
    },
    {
        path: 'administration/imgUploadCqMerge',
        component: resolve => require(['@/components/administration/imgUploadCqMerge'],resolve),
        name:'ImgUploadCqMerge',
        meta:{
            id:'725',
            node:'administration',
            url:'imgUploadCqMerge',
        }
    },
    {
        path: 'administration/viewEntryTzCqMerge',
        component: resolve => require(['@/components/administration/viewEntryTzCqMerge'],resolve),
        name:'ViewEntryTzCqMerge',
        meta:{
            id:'724',
            node:'administration',
            url:'viewEntryTzCqMerge',
        }
    },
    {
        path: 'administration/addSaleTzCqMerge',
        component: resolve => require(['@/components/administration/addSaleTzCqMerge'],resolve),
        name:'AddSaleTzCqMerge',
        meta:{
            id:'728',
            node:'administration',
            url:'addSaleTzCqMerge',
        }
    },
    {
        path: 'administration/editSaleTzCqMerge',
        component: resolve => require(['@/components/administration/editSaleTzCqMerge'],resolve),
        name:'EditSaleTzCqMerge',
        meta:{
            id:'729',
            node:'administration',
            url:'editSaleTzCqMerge',
        }
    },
    {
        path: 'administration/viewSaleTzCqMerge',
        component: resolve => require(['@/components/administration/viewSaleTzCqMerge'],resolve),
        name:'ViewSaleTzCqMerge',
        meta:{
            id:'730',
            node:'administration',
            url:'viewSaleTzCqMerge',
        }
    },
    {
        path: 'administration/supplierMgmMerge',
        component: resolve => require(['@/components/administration/supplierMgmMerge'],resolve),
        name:'SupplierMgmMerge',
        meta:{
            id:'732',
            node:'administration',
            url:'supplierMgmMerge',
        }
    },
    {
        path: 'administration/newSupplierMerge',
        component: resolve => require(['@/components/administration/newSupplierMerge'],resolve),
        name:'NewSupplierMerge',
        meta:{
            id:'733',
            node:'administration',
            url:'newSupplierMerge',
        }
    },
    {
        path: 'administration/viewSupplierMerge',
        component: resolve => require(['@/components/administration/viewSupplierMerge'],resolve),
        name:'ViewSupplierMerge',
        meta:{
            id:'735',
            node:'administration',
            url:'viewSupplierMerge',
        }
    },
    {
        path: 'administration/editSupplierMerge',
        component: resolve => require(['@/components/administration/editSupplierMerge'],resolve),
        name:'EditSupplierMerge',
        meta:{
            id:'734',
            node:'administration',
            url:'editSupplierMerge',
        }
    },
    {
        path: 'administration/clientMgmMerge',
        component: resolve => require(['@/components/administration/clientMgmMerge'],resolve),
        name:'ClientMgmMerge',
        meta:{
            id:'747',
            node:'administration',
            url:'clientMgmMerge',
        }
    },
    {
        path: 'administration/newClientMerge',
        component: resolve => require(['@/components/administration/newClientMerge'],resolve),
        name:'NewClientMerge',
        meta:{
            id:'748',
            node:'administration',
            url:'newClientMerge',
        }
    },
    {
        path: 'administration/viewClientMerge',
        component: resolve => require(['@/components/administration/viewClientMerge'],resolve),
        name:'ViewClientMerge',
        meta:{
            id:'750',
            node:'administration',
            url:'viewClientMerge',
        }
    },
    {
        path: 'administration/editClientMerge',
        component: resolve => require(['@/components/administration/editClientMerge'],resolve),
        name:'EditClientMerge',
        meta:{
            id:'749',
            node:'administration',
            url:'editClientMerge',
        }
    },
    {
        path: 'administration/stocksMerge',
        component:resolve => require(['@/components/administration/stocksMerge'],resolve),
        name:"StocksMerge",
        meta:{
            id:'737',
            node:'administration',
            url:'stocksMerge',
        }
    },
    {
        path: 'administration/editStocksMerge',
        component:  resolve => require(['@/components/administration/editStocksMerge'],resolve),
        name:'EditStocksMerge',
        meta:{
            id:'739',
            node:'administration',
            url:'editStocksMerge',
        }
    },
    {
        path: 'administration/viewStocksMerge',
        component:  resolve => require(['@/components/administration/viewStocksMerge'],resolve),
        name:'ViewStocksMerge',
        meta:{
            id:'740',
            node:'administration',
            url:'viewStocksMerge',
        }
    },
    {
        path: 'administration/marketMerge',
        component:  resolve => require(['@/components/administration/marketMerge'],resolve),
        name:'MarketsMerge',
        meta:{
            id:'742',
            node:'administration',
            url:'marketMerge',
        }
    },
    {
        path: 'administration/editMarketMerge',
        component:  resolve => require(['@/components/administration/editMarketMerge'],resolve),
        name:'EditMarketMerge',
        meta:{
            id:'744',
            node:'administration',
            url:'editMarketMerge',
        }
    },
    {
        path: 'administration/viewMarketMerge',
        component:  resolve => require(['@/components/administration/viewMarketMerge'],resolve),
        name:'ViewMarketMerge',
        meta:{
            id:'745',
            node:'administration',
            url:'viewMarketMerge',
        }
    },
    {
        path: 'administration/newStocksMerge',
        component:  resolve => require(['@/components/administration/newStocksMerge'],resolve),
        name:'NewStocksMerge',
        meta:{
            id:'738',
            node:'administration',
            url:'newStocksMerge',
        }
    },
    {
        path: 'administration/newMarketMerge',
        component:  resolve => require(['@/components/administration/newMarketMerge'],resolve),
        name:'NewMarketMerge',
        meta:{
            id:'743',
            node:'administration',
            url:'newMarketMerge',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/administration.js